<template>
    <div class="popup_overlay px-4">
    <div class="custom_dialog rounded-xl" style="width: 820px; overflow: auto; max-height: 85%;">
      <div class="relative">
        <div>
          <div class="bg-primary flex justify-between p-3">
            <div class=" font-medium text-white heading-3">
              <span >Update Job</span>
            </div>
          </div>
          <div class="p-4">
            <div class="col-span-2 mb-4 sm:mb-0">
               <p class="label_css"  >Select Job Type</p>
               <div class="flex flex-wrap">
                 <span class="" v-for="(type, index) in jobTypeList" :key="index" >
                  <span @click="selectJobType(type)" :class="`mb-2 flex items-center justify-center w-fit heading-6 whitespace-nowrap border rounded-2xl  text-${SelectrdjobTypeId === type.jobTypeId ? 'primary' : ''} border-${SelectrdjobTypeId === type.jobTypeId ? 'primary' : 'gray2'} px-2 py-1  mr-1`">
                    {{type.jobTypeName}}</span>
                </span> 
               </div>
            </div>
            <div class="mt-4 mb-4">
              <div class="flex items-center py-1">
                 <CheckBoxInput :checkValue="isBillable" :label="`Billable`" :size="'small'" :disabled="false" @setIsActive="isBillable = !isBillable"/>
                  </div>
            </div>
            <!-- Date Picker & Time Selection -->
            <div class="date_picker_box md:grid gap-4 grid-cols-2">
              <div class="flex justify-center">
                <div style="width: 305px" class="mb-4">
                  <DateTimePickerCustom
                    v-model="visitStartDateTime"
                    :key="visitStartDateTime"
                    :title="''"
                    :showOnlyDate="true"
                    :hideGoToday="true"
                    :hideBtn="true"
                    :roundedCard="true"
                    :autoAdvanceToNextDayIfAfter7pm="true"
                    @input="updateDate"
                  />
                </div>
              </div>
              <div class="mb-4">
                <div class="w-full mb-4">
                  <!-- All Day Checkbox -->
                  <div class="mb-4 flex items-center">
                    <input
                      type="checkbox"
                      v-model="isAllDay"
                      id="all-day-event"
                      class="h-4 w-4 text-primary focus:ring-primary border-gray-300 rounded"
                    />
                    <label for="all-day-event" class="ml-2 text-text1">All-day event</label>
                  </div>

                  <!-- Time Pickers -->
                  <div v-if="!isAllDay" class="flex flex-col sm:flex-col gap-4">
                    <div class="w-full sm:flex-1">
                      <label class="text-text1 font-semibold heading-5 block mb-1">Start Time</label>
                      <CustomTimePicker
                        v-model="startTime"
                        :time-options="timeOptions"
                        placeholder="Select or enter time"
                        @input="setVisitTime"
                      />
                    </div>
                    <div class="w-full sm:flex-1">
                      <label class="text-text1 font-semibold heading-5 block mb-1">End Time</label>
                      <CustomTimePicker
                        v-model="endTime"
                        :time-options="endTimeOptions"
                        placeholder="Select or enter time"
                        @input="setVisitTime"
                      />
                    </div>
                  </div>
                  <p v-if="timeErr" class="text-error text-sm mt-2">End time must be after start time</p>
                </div>
              </div>
            </div>
          </div>
        </div>
          <div class=" sticky bottom-0 bg-white w-full flex justify-end pr-3">
            <div class="text-rigth flex gap-2 mb-3">
                <Button :btnSize="'medium'" :textColor="'text1'" :btnColor="'gray1'" :btnText="'Discard'" @buttonAction="discard()"/>
                <Button  :btnSize="'medium'" :textColor="'white'" :btnColor="'success'" :btnText="'Save'" @buttonAction="saveNote()"/>
            </div>
            </div>
        </div>
    </div>
  </div>
</template>
<script>
import Button from '@/View/components/globalButton.vue'
import CheckBoxInput from '../../components/checkBoxInput.vue'
import CustomTimePicker from './timePicker.vue'
import MyJobApp from '@/api/MyJobApp.js'
import moment from 'moment'
import DateTimePickerCustom from '@/View/components/dateTimepicker'

export default {
  name: 'addUpdatenote',
  components: {
    Button,
    CheckBoxInput,
    CustomTimePicker,
    DateTimePickerCustom,
  },
  data () {
    return {
        startTime: "11:30",
        endTime: "12:30",
        timeErr: false,
        jobTypeList: [],
        instruction: '',
        titleErr: '',
        isBillable: false,
        SelectrdjobTypeId: null,
        jobEstimation: 0,
        visitStartDateTime: '',
        visitEndDateTime: '',
        isAllDay: false,
        formattedStartDateTime : '',
        formattedEndDateTime : ''
    }
  },
  props: ['detail', 'visitDetail', 'reqType'],
  computed: {
    timeOptions() {
      const times = [];
      for (let hour = 0; hour < 24; hour++) {
        for (let minute of [0, 15, 30, 45]) {
          const timeStr = `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}`;
          const display = this.formatTimeDisplay(timeStr);
          times.push({ value: timeStr, display });
        }
      }
      return times;
    },
    endTimeOptions() {
      return this.timeOptions.map(time => {
        const duration = this.calculateDuration(this.startTime, time.value);
        return { ...time, duration };
      }).filter(time => !this.isInvalidEndTime(time.value));
    }
  },
  created() {
  },
  mounted () {
    this.isBillable = this.detail.isBillable
    this.SelectrdjobTypeId = this.detail.jobTypeId
    document.body.style = 'overflow: hidden;'
    this.jobTypelist()

    // const now = moment().format('YYYY-MM-DD')
    // this.visitStartDateTime = now
    // this.visitEndDateTime = now
    this.visitStartDateTime = this.visitDetail.visitStartDateTime
    this.visitEndDateTime = this.visitDetail.visitEndDateTime
    // Initialize startTime and endTime from visitDetail
    if (this.visitDetail) {
      this.startTime = moment(new Date(this.visitDetail.visitStartDateTime)).format('HH:mm');
      this.endTime = moment(new Date(this.visitDetail.visitEndDateTime)).format('HH:mm');
    } else if (this.detail.jobEstimation) {
      // Fallback to jobEstimation if visitDetail is not available
      const hours = Math.floor(this.detail.jobEstimation / 60);
      const minutes = this.detail.jobEstimation % 60;
      this.startTime = `00:00`;
      this.endTime = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
    }
    this.setVisitTime();
  },
  watch: {
    startTime() {
      this.validateTimes();
      this.setVisitTime();
    },
    endTime() {
      this.validateTimes();
      this.setVisitTime();
    },
    isAllDay(val) {
      if (val) {
        this.startTime = '00:00'
        this.endTime = '23:59'
        this.setVisitTime()
      } else {
        this.setDefaultTime()
      }
    },
    visitStartDateTime(newDate) {
      this.visitEndDateTime = newDate
      this.setVisitTime()
    }
  },
  methods: {
    setDefaultTime() {
      const now = new Date()
      let hours = now.getHours()
      let minutes = Math.ceil(now.getMinutes() / 15) * 15
      if (minutes === 60) {
        hours++
        minutes = 0
      }
      this.startTime = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`
      this.endTime = `${(hours + 1).toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`
      this.setVisitTime()
    },
    updateDate() {
      // Ensure visitEndDateTime is in sync with visitStartDateTime
      this.$set(this, 'visitEndDateTime', moment(this.visitStartDateTime).format('YYYY-MM-DD'));
      this.setVisitTime();
    },
    formatTimeDisplay(time) {
      const [hours, minutes] = time.split(':').map(Number);
      const period = hours >= 12 ? 'PM' : 'AM';
      const displayHour = hours === 0 ? 12 : hours > 12 ? hours - 12 : hours;
      return `${displayHour}:${minutes.toString().padStart(2, '0')} ${period}`;
    },
    calculateDuration(start, end) {
      if (!start || !end) return '';
      const startDate = moment(`2023-01-01 ${start}`);
      const endDate = moment(`2023-01-01 ${end}`);
      if (!endDate.isAfter(startDate)) return '';
      
      const duration = moment.duration(endDate.diff(startDate));
      const hours = Math.floor(duration.asHours());
      const minutes = Math.floor(duration.asMinutes()) % 60;
      
      let durationStr = '';
      if (hours > 0) durationStr += `${hours} hr${hours > 1 ? 's' : ''}`;
      if (minutes > 0) durationStr += `${durationStr ? ' ' : ''}${minutes} min${minutes > 1 ? 's' : ''}`;
      return durationStr;
    },
    isInvalidEndTime(end) {
      if (!this.startTime || !end) return false;
      const startDate = moment(`2023-01-01 ${this.startTime}`);
      const endDate = moment(`2023-01-01 ${end}`);
      return !endDate.isAfter(startDate);
    },
    validateTimes() {
      this.timeErr = false;
      if (this.startTime && this.endTime) {
        const start = moment(`2023-01-01 ${this.startTime}`);
        const end = moment(`2023-01-01 ${this.endTime}`);
        this.timeErr = !end.isAfter(start);
      }
    },
    setVisitTime() {
      let visitDate = moment(this.visitStartDateTime).format('YYYY-MM-DD')
      let isAllDayEvent = this.isAllDay
      let finalStartTime = this.startTime
      let finalEndTime = this.endTime

      // const startTimeMoment = moment(`2023-01-01 ${this.startTime}`)
      // const sevenPM = moment('2023-01-01 20:00')

      // if (startTimeMoment.isSameOrAfter(sevenPM) && !this.isAllDay) {
      //   visitDate = moment(this.visitStartDateTime).add(1, 'days').format('YYYY-MM-DD')
      //   isAllDayEvent = true
      //   finalStartTime = '00:00'
      //   finalEndTime = '23:59'
      // }

      const durationStr = this.calculateDuration(finalStartTime, finalEndTime)
      this.jobEstimation = this.parseDurationToMinutes(durationStr)

      // Update if all-day changed
      if (this.isAllDay !== isAllDayEvent) {
        this.isAllDay = isAllDayEvent
      }

      // Update date if changed
      if (visitDate !== moment(this.visitStartDateTime).format('YYYY-MM-DD')) {
        this.visitStartDateTime = visitDate
        this.visitEndDateTime = visitDate
      }

      // Combine date with times and format as ISO 8601 (UTC)
      this.formattedStartDateTime = moment(`${visitDate} ${finalStartTime}`, 'YYYY-MM-DD HH:mm').utc().format('YYYY-MM-DDTHH:mm:ss[Z]');
      this.formattedEndDateTime = moment(`${visitDate} ${finalEndTime}`, 'YYYY-MM-DD HH:mm').utc().format('YYYY-MM-DDTHH:mm:ss[Z]');

      // Logging
      console.log('Visit Start Date:', this.visitStartDateTime)
      console.log('Start Time:', this.formattedStartDateTime)
      console.log('End Time:', this.formattedEndDateTime)
      console.log('Duration (min):', this.jobEstimation)
    },
    parseDurationToMinutes(durationStr) {
      if (!durationStr) return 0;
      let hours = 0, minutes = 0;
      const hourMatch = durationStr.match(/(\d+)\s*hrs?/);
      if (hourMatch) {
        hours = parseInt(hourMatch[1], 10);
      }
      const minuteMatch = durationStr.match(/(\d+)\s*mins?/);
      if (minuteMatch) {
        minutes = parseInt(minuteMatch[1], 10);
      }
      return (hours * 60) + minutes;
    },
    jobTypelist() {
      MyJobApp.jobTypelist(
        (response) => {
          this.jobTypeList = response.Data
        },
        (err) => {
          this.$store.dispatch("SetAlert", {
            showAlert: true,
            message: err.message,
            color: "error",
          });
          this.$store.dispatch("SetLoader", { status: false, message: "" });
        }
      );
    },
    selectJobType(data) {
      this.SelectrdjobTypeId = data.jobTypeId
      this.setVisitTime()
    },
    saveNote () {
        let isValid = true
        if (this.SelectrdjobTypeId < 0 || this.detail.jobId < 0 || this.timeErr) {
            isValid = false
        }
        let data = {
            jobId: this.detail.jobId,
            jobTypeId: this.SelectrdjobTypeId,
            jobEstimation: this.jobEstimation,
            isBillable: this.isBillable,
            visitId: this.visitDetail.visitId,
            startTime: this.formattedStartDateTime,
            endTime: this.formattedEndDateTime,
            visitEstimation: this.jobEstimation
        }
        // Console log startTime, endTime, and duration
        console.log('Start Time:', this.formattedStartDateTime);
        console.log('End Time:', this.formattedEndDateTime);
        console.log('Duration (minutes):', this.jobEstimation);
        console.log('Visit Start Date:', this.visitStartDateTime)
        console.log('All-day Event:', this.isAllDay)
        
        if (isValid) {
          this.$store.dispatch('SetLoader', {status: true, message: 'Loading...'})
          MyJobApp.updateJobDetail(
            [],
            this.reqType,
            data,
            '',
            response => {
              document.body.style = 'overflow: visible;'
              this.$emit('updateJobTypeHandler', true)
              this.$store.dispatch('SetAlert', {showAlert: true, message: response.message, color: 'success'})
              this.$store.dispatch('SetLoader', {status: false, message: ''})
            },
            (error) => {
              this.$store.dispatch('SetAlert', {showAlert: true, message: error.message, color: 'error'})
              this.$store.dispatch('SetLoader', {status: false, message: ''})
            }
          )
        }
    },
    discard () {
      document.body.style = 'overflow: visible;'
      this.$emit('updateJobTypeHandler', false)
    },
  },
  beforeDestroy () {
  }
}
</script>
<style scoped>
</style>